{
  "header": {
    "welcomeMessage": "Welcome, {{firstName}}!",
    "description": "Review and analyze previous feedback responses"
  },
  "emptyState": {
    "company": {
      "title": "No data collected yet",
      "description": "Your journey starts here! Once employees begin sharing feedback for first month, you’ll see insights and trends appear"
    },
    "directReports": {
      "title": "No direct reports",
      "description": "You don’t have any direct reports assigned to you, but you can still participate in surveys and share valuable feedback!",
      "bottomAction": {
        "label": "If you think this is a mistake, contact your manager",
        "helpText": "Help text"
      }
    }
  },
  "tabs": {
    "company": "Entire company",
    "allReports": "All reports",
    "directReports": "Direct reports",
    "myTeam": "My team"
  },
  "keysInsights": {
    "title": "Keys Insights",
    "strengths": {
      "title": "Strengths",
      "tooltipTitle": "Help text"
    },
    "growthAreas": {
      "title": "Growth areas",
      "tooltipTitle": "Help text"
    }
  },
  "enps": {
    "title": "eNPS",
    "chart": {
      "description": "eNPS measures how likely employees are to recommend their workplace, reflecting overall engagement and satisfaction"
    },
    "scoreTitle": "Your team",
    "companyAverageTitle": "Company eNPS"
  },
  "overview": {
    "title": "Overview",
    "scoreTitle": "Your team",
    "companyAverageTitle": "Company average"
  }
}
